export const fieldsName = {
  groupName: 'groupName',
  groupDesc: 'groupDesc',
};
